import { Component, HostBinding } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngxs/store';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { AuthState } from 'src/app/store/auth/auth.state';
import { environment } from 'src/environments/environment';

@UntilDestroy()
@Component({
  selector: 'app-announce-button',
  templateUrl: './announce-button.component.html',
  styleUrls: ['./announce-button.component.scss'],
})
export class AnnounceButtonComponent {
  announceKitUrl = environment.announceKitUrl;
  @HostBinding('class.announce-kit-disabled') announceKitDisabled = !this.announceKitUrl;
  // Note: Following type conversion is because of imporper type def in announcekit-angular
  labels = ['fix', 'Feature Announcement', 'announcement', 'improvement', 'minor update'] as unknown as [string];

  userData$ = new BehaviorSubject<{ id: string, [x: string]: any }>(null);
  segmentData$ = new BehaviorSubject<{ [x: string]: any }>(null);

  constructor(private store: Store) {
      combineLatest([
        this.store.select(AuthState.company),
        this.store.select(AuthState.user),
      ]).pipe(untilDestroyed(this))
      .subscribe(([company, user]) => {
        this.userData$.next({ id: user?.id });
        this.segmentData$.next({
          environment: environment.env.NODE_ENV,
          pricing_plan: company?.pricingPlan,
          company_id: company?.id,
          user_role: company?.role,
          company_size: company?.userCount,
          tracking_type: company?.companySettings?.trackingMode,
          billing_system: company?.subscription?.provider,
        });
      });
  }
}
